import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { DurationUnitEnum } from '../../../shared/enums/duration-unit.enum';

import { QuotationPricingItemPreset } from './quotation-pricing-item-preset';

/**
 * Quotation request parameters
 */
export class QuotationRequestParams {
	/**
	 * Reservation UUID
	 */
	reservationUuid?: string;

	/**
	 * Agent UUID
	 */
	agentUuid?: string;

	/**
	 * Agent ID (preferred for tenant-internal callers; the manage app form already holds this)
	 */
	agentId?: number;

	/**
	 * Duration Unit
	 */
	durationUnit!: DurationUnitEnum;

	/**
	 * Date From
	 */
	@TransformDate()
	dateFrom!: Date;

	/**
	 * Date To
	 */
	@TransformDate()
	dateTo!: Date;

	/**
	 * Pricing items
	 */
	pricingItems?: QuotationPricingItemPreset[];
}
